import { FetchError, type FetchResponse } from 'ofetch'

export function isFetchError(error: unknown): error is FetchError {
  return error instanceof FetchError
}

function isGatewayResponse(response?: FetchResponse<unknown>) {
  return response?.headers.get('X-Gateway-Event')?.toLowerCase() === 'true'
}

export function isGatewayUnauthResponse(response?: FetchResponse<unknown>) {
  return isGatewayResponse(response) && response?.status === 401
}

/** The gateway's only own 403: the session was ended in Keycloak (e.g. user suspended). Backend 403s lack the header. */
export function isGatewaySessionRevokedResponse(response?: FetchResponse<unknown>) {
  return isGatewayResponse(response) && response?.status === 403
}
